import classNames from "classnames";
import { Typography } from "components/atoms";
import "./index.scss";

interface IProps {
    content: string;
}

export const FetchError = ({ content }: IProps) => {
    return (
        <div className={classNames("fetch-error-wrapper")}>
            <Typography styles="fetch-error-msg" variant="h7Med" label={content} />
        </div>
    )
}